import { motion, MotionStyle } from 'framer-motion';
type Props = { children?: React.ReactNode; className?: string; styles?: MotionStyle; duration?: number };

export const MotionDiv = ({ children, className, styles, duration = 0.3 }: Props) => {
  return (
    <motion.div
      className={`${className}`}
      initial={{ scale: 0.99, opacity: 0.2 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: duration }}
      style={styles}
    >
      {children}
    </motion.div>
  );
};
